import axios from "axios";

export const api = ({ dispatch }) => (next) => (action) => {
    if (action.type !== 'api/apiCall') {
        return next(action);
    }

    const { url, method, data, onSuccess, onFail, headers } = action.payload;

    // Bazaviy config
    const config = {
        baseURL: 'https://express.bekzodbek.uz/api/',
        url,
        method,
        data,
        headers: { ...headers }  // default headers bo‘sh yoki topshirilgan bo‘lsa
    };

    try {
        const rawToken = localStorage.getItem('token');
        const token = JSON.parse(rawToken);

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    } catch (e) {
        // Token noto‘g‘ri formatda bo‘lsa yoki mavjud bo‘lmasa, hech narsa qilinmaydi
    }

    axios(config)
        .then(response => {
            dispatch({
                type: onSuccess,
                payload: response.data,
            });
        })
        .catch(error => {
            dispatch({
                type: onFail,
                payload: error?.response?.data || { error: 'Server error' },
            });
        });

    return next(action);
}